import api from './api';

const BASE = '/validacion';

export const validacionService = {
    obtenerEstado: async (modulo, sesion, ct = null) => {
        const response = await api.get(`${BASE}/estado`, { params: { modulo, sesion, ct: ct || undefined } });
        return response.data;
    },

    validar: async (modulo, sesion, estado, ct = null, comentario = null) => {
        const response = await api.post(`${BASE}/validar`, { modulo, sesion, ct, estado, comentario });
        return response.data;
    },
};
